import React from 'react';
import { composer } from '../../component-decorators/composer';
import { sendAddAppBi } from '../../bi/biEvents';
import { TextButton, EmptyState } from 'wix-style-react';
export var AddAppBox = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, goToHomePage = _a.goToHomePage, origin = _a.origin, msid = _a.msid, editorType = _a.editorType;
    return (React.createElement(EmptyState, { theme: "page", title: t('manage-apps.empty-state.title'), subtitle: t('manage-apps.empty-state.subtitle') },
        React.createElement(TextButton, { dataHook: 'go-to-app-market-button', onClick: function () {
                sendAddAppBi(origin, msid, editorType);
                goToHomePage();
            } }, t('manage-apps.empty-state.go-to-app-market'))));
});
//# sourceMappingURL=add-app-box.js.map